import { render } from "./Protoc.vue?vue&type=template&id=1556083b&scoped=true&ts=true"
import script from "./Protoc.vue?vue&type=script&lang=ts"
export * from "./Protoc.vue?vue&type=script&lang=ts"

import "./Protoc.vue?vue&type=style&index=0&id=1556083b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1556083b"]])

export default __exports__